// extracted by mini-css-extract-plugin
module.exports = {"modal_animation_duration":"200ms","documentContainer":"onfido-sdk-ui-Capture-documentContainer","faceContainer":"onfido-sdk-ui-Capture-faceContainer"};